import { CheckCircle2, XCircle } from "lucide-react";
import { Card, ScoreBadge } from "./ui";

export const SeoReport = ({ result, testid = "seo-report" }) => (
  <Card title="SEO score" testid={testid}>
    <div className="flex items-center gap-4">
      <ScoreBadge score={result.score} size="lg" testid={`${testid}-score`} />
      <div className="text-sm text-zinc-400">
        <p className="font-medium text-white">{result.score >= 80 ? "Great — well optimised" : result.score >= 50 ? "Good, can be improved" : "Needs work"}</p>
        <p className="mt-1 text-xs">{result.words} words · keyword density {result.density.toFixed(2)}%</p>
      </div>
    </div>
    <ul className="mt-5 space-y-2.5">
      {result.checks.map((c) => (
        <li key={c.label} className="flex gap-2.5 text-sm">
          {c.pass ? <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-emerald-400" /> : <XCircle size={16} className="mt-0.5 shrink-0 text-red-400" />}
          <span>
            <span className={c.pass ? "text-zinc-300" : "text-white"}>{c.label}</span>
            {!c.pass && <span className="block text-xs text-zinc-500">{c.tip}</span>}
          </span>
        </li>
      ))}
    </ul>
  </Card>
);
